import { render } from "./LanguagesList.vue?vue&type=template&id=1d3439da&scoped=true&ts=true"
import script from "./LanguagesList.vue?vue&type=script&lang=ts"
export * from "./LanguagesList.vue?vue&type=script&lang=ts"

import "./LanguagesList.vue?vue&type=style&index=0&id=1d3439da&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3439da"]])

export default __exports__